import React, { ReactElement } from 'react';
import './tooltip-content.scss';

export interface TooltipContentProps {
    title: JSX.Element;
    onClose: () => void;
}

const TooltipContent: React.FC<TooltipContentProps> = ({
    title,
    onClose,
    children
}): ReactElement => (
    <div className="tooltip-content">
        <div className="tooltip-content__title">
            <div className="tooltip-content__title-text">
                {title}
            </div>
            <i className="icon-close tooltip-content__title-exit" onClick={onClose} role="button"
                tabIndex={0} aria-label="Zamknij"
            />
        </div>
        {children}
    </div>
);

export default TooltipContent;
